export const shouldUpdateCarInfoVin = (state) => {
  const dealStates = ['final_parameters', 'recalculation_desired', 'awaiting_manual_final_params'];

  return dealStates.includes(state?.name);
};

export const isCarInfoEmpty = (data) => {
  const excludeFields = [
    'bodyNumber',
    'engine',
    'engineNumber',
    'enginePower',
    'maxWeight',
    'price',
    'pts',
    'ptsIssueDate',
    'year',
  ];

  return excludeFields.every((f) => {
    return !data?.[f];
  });
};

// Заменяем недопустимые в vin символы (ошибки распознавания)
export const fixRecognizedVin = (vin = '') => {
  const mapObj = {
    O: '0',
    I: '1',
    Q: '9',
  };
  const keys = Object.keys(mapObj).join('|');
  const replaced = vin.replace(new RegExp(keys, 'g'), (matched) => {
    return mapObj[matched];
  });

  return replaced;
};
